<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.Calculation.Title }}
            <span class="subtitle hero-subtitle">{{ $lang.Calculation.NewTitle_3 }}</span>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-catalog-request" icon-left="plus-box-outline" @click="openCircuitDevices">{{ [$lang.Calculation.InnerTitle_14, $lang.Calculation.InnerTitle_15, $lang.Calculation.InnerTitle_16].join(' ') }}</b-button>
            </p>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right">
                <b-button class="button is-primary" @click="submit">{{ $lang.Menus.ContinueBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body calc-body calc-summary">
                <calculationTabs />
                <outputCircBtns />

                <b-loading v-if="isLoading" :is-full-page="false" :active="true" :can-cancel="false"></b-loading>

                <!-- Busbars -->
                <template v-if="busbardevicesdata.length">
                    <p class="wizard-card-head">{{ $lang.Calculation.NewTitle_4 }}</p>
                    <div class="calc-table-card">
                        <b-table class="data-table is-flush" style="--table-min: 800px" :data="busbardevicesdata">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">{{ props.row.Definition }}</b-table-column>
                            <b-table-column field="Width_Thickness" :label="$lang.CalcCircInfos.BusbarDimension" v-slot="props" width="96">{{ props.row.Width_Thickness }}</b-table-column>
                            <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" v-slot="props" width="84" numeric>{{ props.row.ConductorTemperature }}</b-table-column>
                            <b-table-column field="MaxTemperature" width="112" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template><template v-slot="props">{{ props.row.MaxTemperature }}</template></b-table-column>
                            <b-table-column field="I_Max" width="72" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template><template v-slot="props">{{ truncate(props.row.I_Max, 1) }}</template></b-table-column>
                            <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" v-slot="props" width="96" numeric>{{ props.row.ConductorLength }}</b-table-column>
                            <b-table-column field="PhasesNumber" :label="$lang.CalcCircInfos.PhaseNumber" v-slot="props" width="64" numeric>{{ props.row.PhasesNumber }}</b-table-column>
                            <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" v-slot="props" width="84" numeric>{{ truncate(props.row.LostPower, 1) }}</b-table-column>
                            <b-table-column field="CalcResult" width="84" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template><template v-slot="props">{{ truncate(props.row.CalcResult, 1) }}</template></b-table-column>
                        </b-table>
                        <div class="calc-total"><span>{{ $lang.CalcCircInfos.Total_P_Busbar }}</span><b>{{ truncate(total_P_Busbar, 1) }}</b></div>
                    </div>
                </template>

                <!-- Input circuit: its devices and its conductors, shown whichever of them exists
                     (the conductors were hidden when there were no devices, yet counted). -->
                <template v-if="inputcirccalculationdevicesdata.length || conductordevicesdata.length">
                    <p class="wizard-card-head">{{ $lang.Calculation.NewTitle_5 }}</p>
                    <div class="calc-table-card">
                        <b-table v-if="inputcirccalculationdevicesdata.length" class="data-table is-flush" style="--table-min: 860px" :data="inputcirccalculationdevicesdata">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">{{ props.row.Definition }}</b-table-column>
                            <b-table-column field="Type" :label="$lang.CalcCircInfos.Type" v-slot="props">{{ props.row.Type }}</b-table-column>
                            <b-table-column field="Brand" :label="$lang.CalcCircInfos.Brand" v-slot="props" width="96">{{ props.row.Brand }}</b-table-column>
                            <b-table-column field="Code" :label="$lang.CalcCircInfos.Code" v-slot="props">{{ props.row.Code }}</b-table-column>
                            <b-table-column field="In_Value" width="70" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.In_A"></span></template><template v-slot="props">{{ props.row.In_Value }}</template></b-table-column>
                            <b-table-column field="Pole" :label="$lang.CalcCircInfos.PoleNumber" v-slot="props" width="76">{{ props.row.Pole }}</b-table-column>
                            <b-table-column field="Sbt_Cekmeceli" :label="$lang.CalcCircInfos.Sbt_cekmeceli" v-slot="props" width="96">{{ props.row.Sbt_Cekmeceli }}</b-table-column>
                            <b-table-column field="Power" :label="$lang.CalcCircInfos.Power" v-slot="props" width="76">{{ props.row.Power }}</b-table-column>
                            <b-table-column field="Pv" width="84" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template><template v-slot="props">{{ truncate(props.row.Pv, 1) }}</template></b-table-column>
                        </b-table>
                        <b-table v-if="conductordevicesdata.length" class="data-table is-flush is-joined" style="--table-min: 960px" :data="conductordevicesdata">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">{{ props.row.Definition }}</b-table-column>
                            <b-table-column field="ConnectionType" :label="$lang.CalcCircInfos.ConnType" v-slot="props" width="84">{{ props.row.ConnectionType }}</b-table-column>
                            <b-table-column field="CablePosition" :label="$lang.CalcCircInfos.CablePos" v-slot="props" width="84">{{ props.row.CablePosition }}</b-table-column>
                            <b-table-column field="PhaseNumber" :label="$lang.CalcCircInfos.PhaseNumber" v-slot="props" width="64" numeric>{{ props.row.PhaseNumber }}</b-table-column>
                            <b-table-column field="DimensionInfo" :label="$lang.CalcCircInfos.ConductorDimension" v-slot="props" width="96">{{ props.row.DimensionInfo }}</b-table-column>
                            <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" v-slot="props" width="96" numeric>{{ props.row.ConductorLength }}</b-table-column>
                            <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" v-slot="props" width="84" numeric>{{ props.row.ConductorTemperature }}</b-table-column>
                            <b-table-column field="MaxTemperature" width="112" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template><template v-slot="props">{{ props.row.MaxTemperature }}</template></b-table-column>
                            <b-table-column field="I_Max" width="72" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template><template v-slot="props">{{ truncate(props.row.I_Max, 1) }}</template></b-table-column>
                            <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" v-slot="props" width="84" numeric>{{ truncate(props.row.LostPower, 1) }}</b-table-column>
                            <b-table-column field="CalcResult" width="84" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template><template v-slot="props">{{ truncate(props.row.CalcResult, 1) }}</template></b-table-column>
                        </b-table>
                        <div class="calc-total"><span>{{ $lang.CalcCircInfos.Total_P_InpCirc }}</span><b>{{ truncate(total_P_InputCircuit, 1) }}</b></div>
                    </div>
                </template>

                <!-- Output circuits: a row per circuit, its items under it on a click. -->
                <template v-if="circuitcalculationdevicesdata_detailed.length || circuitdeviceconductorsdata_detailed.length || subdistributionbusbarsdata_detailed.length">
                    <p class="wizard-card-head">{{ $lang.Calculation.NewTitle_6 }}</p>
                    <div class="calc-table-card">
                        <b-table v-if="circuitcalculationdevicesdata_detailed.length" class="data-table is-flush" style="--table-min: 1120px" :data="circuitcalculationdevicesdata_detailed" detailed custom-detail-row :show-detail-icon="false" detail-key="CircuitIndex">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                                <a class="detail-toggle" @click="props.toggleDetails(props.row)">{{ props.row.Definition }}</a>
                            </b-table-column>
                            <b-table-column field="NumOfCircuits" :label="$lang.CalcCircInfos.AmountTitle" v-slot="props" width="64" numeric>{{ props.row.NumOfCircuits }}</b-table-column>
                            <b-table-column field="Type" :label="$lang.CalcCircInfos.Type">-</b-table-column>
                            <b-table-column field="Brand" :label="$lang.CalcCircInfos.Brand" width="90">-</b-table-column>
                            <b-table-column field="Code" :label="$lang.CalcCircInfos.Code">-</b-table-column>
                            <b-table-column field="In_Value" width="64" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.In_A"></span></template>-</b-table-column>
                            <b-table-column field="Pole" :label="$lang.CalcCircInfos.PoleNumber" width="70">-</b-table-column>
                            <b-table-column field="Sbt_Cekmeceli" :label="$lang.CalcCircInfos.Sbt_cekmeceli" width="90">-</b-table-column>
                            <b-table-column field="Power" :label="$lang.CalcCircInfos.Power" width="70">-</b-table-column>
                            <b-table-column field="Pv" :label="$lang.CalcCircInfos.Pv" width="84" numeric>-</b-table-column>
                            <b-table-column field="RDF" :label="$lang.CalcCircInfos.RDF" v-slot="props" width="56" numeric>{{ props.row.RDF }}</b-table-column>
                            <b-table-column field="P_CalcResult" width="84" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult2"></span></template>-</b-table-column>
                            <template slot="detail" slot-scope="props">
                                <tr v-for="(item, i) in props.row.Devices" :key="'d' + i" class="detail-row">
                                    <td>{{ item.Definition }}</td>
                                    <td class="has-text-right">{{ item.NumOfCircuits }}</td>
                                    <td>{{ item.Type }}</td>
                                    <td>{{ item.Brand }}</td>
                                    <td>{{ item.Code }}</td>
                                    <td class="has-text-right">{{ item.In_Value }}</td>
                                    <td>{{ item.Pole }}</td>
                                    <td>{{ item.Sbt_Cekmeceli }}</td>
                                    <td>{{ item.Power }}</td>
                                    <td class="has-text-right">{{ truncate(item.Pv, 1) }}</td>
                                    <td class="has-text-right">{{ item.RDF }}</td>
                                    <td class="has-text-right">{{ truncate(item.P_CalcResult, 1) }}</td>
                                </tr>
                            </template>
                        </b-table>
                        <b-table v-if="circuitdeviceconductorsdata_detailed.length" class="data-table is-flush is-joined" style="--table-min: 1240px" :data="circuitdeviceconductorsdata_detailed" detailed custom-detail-row :show-detail-icon="false" detail-key="CircuitIndex">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                                <a class="detail-toggle" @click="props.toggleDetails(props.row)">{{ props.row.Definition }}</a>
                            </b-table-column>
                            <b-table-column field="NumOfCircuits" :label="$lang.CalcCircInfos.AmountTitle" v-slot="props" width="64" numeric>{{ props.row.NumOfCircuits }}</b-table-column>
                            <b-table-column field="ConnectionType" :label="$lang.CalcCircInfos.ConnType" width="100">-</b-table-column>
                            <b-table-column field="CablePosition" :label="$lang.CalcCircInfos.CablePos" width="100">-</b-table-column>
                            <b-table-column field="PhaseNumber" :label="$lang.CalcCircInfos.PhaseNumber" width="60" numeric>-</b-table-column>
                            <b-table-column field="DimensionInfo" :label="$lang.CalcCircInfos.ConductorDimension" width="90">-</b-table-column>
                            <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" width="90" numeric>-</b-table-column>
                            <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" width="80" numeric>-</b-table-column>
                            <b-table-column field="MaxTemperature" width="104" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>-</b-table-column>
                            <b-table-column field="I_Max" width="64" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template>-</b-table-column>
                            <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" width="80" numeric>-</b-table-column>
                            <b-table-column field="RDF" :label="$lang.CalcCircInfos.RDF" v-slot="props" width="56" numeric>{{ props.row.RDF }}</b-table-column>
                            <b-table-column field="P_CalcResult" width="84" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template>-</b-table-column>
                            <template slot="detail" slot-scope="props">
                                <tr v-for="(item, i) in props.row.Devices" :key="'c' + i" class="detail-row">
                                    <td>{{ item.Definition }}</td>
                                    <td class="has-text-right">{{ item.NumOfCircuits }}</td>
                                    <td>{{ item.ConnectionType }}</td>
                                    <td>{{ item.CablePosition }}</td>
                                    <td class="has-text-right">{{ item.PhaseNumber }}</td>
                                    <td>{{ item.DimensionInfo }}</td>
                                    <td class="has-text-right">{{ item.ConductorLength }}</td>
                                    <td class="has-text-right">{{ item.ConductorTemperature }}</td>
                                    <td class="has-text-right">{{ item.MaxTemperature }}</td>
                                    <td class="has-text-right">{{ truncate(item.I_Max, 1) }}</td>
                                    <td class="has-text-right">{{ truncate(item.LostPower, 1) }}</td>
                                    <td class="has-text-right">{{ item.RDF }}</td>
                                    <td class="has-text-right">{{ truncate(item.P_CalcResult, 1) }}</td>
                                </tr>
                            </template>
                        </b-table>
                        <b-table v-if="subdistributionbusbarsdata_detailed.length" class="data-table is-flush is-joined" style="--table-min: 1240px" :data="subdistributionbusbarsdata_detailed" detailed custom-detail-row :show-detail-icon="false" detail-key="CircuitIndex">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.Title_11" v-slot="props" cell-class="cell-strong">
                                <a class="detail-toggle" @click="props.toggleDetails(props.row)">{{ props.row.Definition }}</a>
                            </b-table-column>
                            <b-table-column field="NumOfCircuits" :label="$lang.CalcCircInfos.AmountTitle" v-slot="props" width="64" numeric>{{ props.row.NumOfCircuits }}</b-table-column>
                            <b-table-column field="ConnectionType" :label="$lang.CalcCircInfos.ConnType" width="100">-</b-table-column>
                            <b-table-column field="CablePosition" :label="$lang.CalcCircInfos.CablePos" width="100">-</b-table-column>
                            <b-table-column field="PhaseNumber" :label="$lang.CalcCircInfos.PhaseNumber" width="60" numeric>-</b-table-column>
                            <b-table-column field="DimensionInfo" :label="$lang.CalcCircInfos.ConductorDimension" width="90">-</b-table-column>
                            <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" width="90" numeric>-</b-table-column>
                            <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" width="80" numeric>-</b-table-column>
                            <b-table-column field="MaxTemperature" width="104" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>-</b-table-column>
                            <b-table-column field="I_Max" width="64" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template>-</b-table-column>
                            <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" width="80" numeric>-</b-table-column>
                            <b-table-column field="P_CalcResult" width="84" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template>-</b-table-column>
                            <template slot="detail" slot-scope="props">
                                <tr v-for="(item, i) in props.row.Devices" :key="'b' + i" class="detail-row">
                                    <td>{{ item.Definition }}</td>
                                    <td class="has-text-right">{{ item.NumOfCircuits }}</td>
                                    <td>{{ item.ConnectionType }}</td>
                                    <td>{{ item.CablePosition }}</td>
                                    <td class="has-text-right">{{ item.PhaseNumber }}</td>
                                    <td>{{ item.DimensionInfo }}</td>
                                    <td class="has-text-right">{{ item.ConductorLength }}</td>
                                    <td class="has-text-right">{{ item.ConductorTemperature }}</td>
                                    <td class="has-text-right">{{ item.MaxTemperature }}</td>
                                    <td class="has-text-right">{{ truncate(item.I_Max, 1) }}</td>
                                    <td class="has-text-right">{{ truncate(item.LostPower, 1) }}</td>
                                    <td class="has-text-right">{{ truncate(item.P_CalcResult, 1) }}</td>
                                </tr>
                            </template>
                        </b-table>
                        <div v-if="subdistributionbusbarsdata_detailed.length" class="calc-total is-sub"><span>{{ $lang.CalcCircInfos.Total_P_SubDistBusbars }}</span><b>{{ truncate(total_P_OutputCircuit_SubDistributionBusbars, 1) }}</b></div>
                        <!-- One total for the group: devices and conductors x count, plus the busbars. -->
                        <div class="calc-total"><span>{{ $lang.CalcCircInfos.Total_P_OutputCircs }}</span><b>{{ truncate(allTotal_P_2, 1) }}</b></div>
                    </div>
                </template>

                <!-- Additional powers -->
                <template v-if="manuelcalcdevicesdata.length">
                    <p class="wizard-card-head">{{ $lang.Calculation.NewTitle_7 }}</p>
                    <div class="calc-table-card">
                        <b-table class="data-table is-flush" :data="manuelcalcdevicesdata">
                            <b-table-column field="Explanation" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">{{ props.row.Explanation }}</b-table-column>
                            <b-table-column field="LostPower" width="160" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.LostPower_3"></span></template><template v-slot="props">{{ truncate(props.row.LostPower, 1) }}</template></b-table-column>
                        </b-table>
                        <div class="calc-total"><span>{{ $lang.CalcCircInfos.Total_P_Manuel_2 }}</span><b>{{ truncate(total_P_manuel, 1) }}</b></div>
                    </div>
                </template>

                <!-- The tool's total, as the results step will use it. -->
                <div class="calc-grand-total">
                    <span>{{ $lang.CalcCircInfos.TotalLostPower }}</span>
                    <b>{{ truncate(totalPowerLost, 1) }}</b>
                </div>
            </div>
        </div>

        <b-modal v-model="isCalcWarningModalActive" has-modal-card>
            <div class="modal-card calc-confirm">
                <section class="modal-card-body">
                    <p>{{ $lang.Calculation.CalculationWarning_2 }}</p>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.ModalCloseBtn" type="is-primary" @click="isCalcWarningModalActive = false" />
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import { storeLossTotals } from '@/api/lossTotals';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';
    import OutputCircBtns from '@/components/OutputCircBtns.vue';
    import CalculationTabs from '@/components/CalculationTabs.vue';

    export default {
        name: 'Calc_Summary',
        components: {
            VerticalStepBar,
            OutputCircBtns,
            CalculationTabs
        },
        data() {
            return {
                isActive: true,
                isLoading: false,
                labelPosition: 'on-border',
                projectId: 0,
                currentPage: 1,
                areCalcsEmpty: false,
                isCalcWarningModalActive: false,
                allTotal_P_1: 0,
                allTotal_P_2: 0,

                busbardevicesdata: [],
                total_P_Busbar: 0,

                inputcirccalculationdevicesdata: [],
                conductordevicesdata: [],
                total_P_InputCircuit: 0,

                circuitcalculationdevicesdata_detailed: [],
                total_P_OutputCircuitCalcDevices: 0,
                circuitdeviceconductorsdata_detailed: [],
                total_P_OutputCircuitDeviceConductors: 0,
                subdistributionbusbarsdata_detailed: [],
                total_P_OutputCircuit_SubDistributionBusbars: 0,

                manuelcalcdevicesdata: [],
                total_P_manuel: 0,
                totalPowerLost: 0,
            }
        },
        mounted() {
            this.isLoading = true;
            this.projectId = this.$store.state.projectId;

            this.loadAll();

            this.$store.state.activeStep = 3;
            this.$store.state.isFooterFixed = false;
        },
        watch: {
            $route() {

            }
        },
        methods: {
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/calc_Manuel');
            },
            submit() {
                // Every list counts: a project holding only conductors or sub-distribution
                // busbars was stopped here with "please calculate".
                this.areCalcsEmpty = [this.busbardevicesdata, this.inputcirccalculationdevicesdata, this.conductordevicesdata,
                    this.circuitcalculationdevicesdata_detailed, this.circuitdeviceconductorsdata_detailed,
                    this.subdistributionbusbarsdata_detailed, this.manuelcalcdevicesdata].every((list) => list.length == 0);
                if (this.areCalcsEmpty) {
                    this.isCalcWarningModalActive = true;
                }

                if (!this.areCalcsEmpty) {
                    this.$store.isPageOpenedFromStepBar = false;
                    this.$store.canResultOpen = true;
                    this.$store.state.calcIndexFromOutputCircs = -1;

                    // Written before the results step opens: it reads totalLostPower_3 on mount.
                    storeLossTotals(this.$store, this.projectId).then(() => {
                        if (this.$store.state.memberId == 'TestMember') {
                            router.push('/LoginMember');
                        } else {
                            this.$store.state.isCompleted = true;
                            router.push('/results');
                        }
                    }).catch(() => {
                        this.$buefy.dialog.alert(this.$errorModal({}));
                    });
                }
            },

            // Everything at once. This was a thirteen-step chain: a failed step stopped it with the
            // full-page loader still up, and the grand total raced a request of its own.
            loadAll() {
                this.isLoading = true;
                const pid = this.projectId;
                const list = (res) => {
                    if (!res || res.isError) throw res || new Error('No answer');
                    return res.data || [];
                };

                Promise.all([
                    api.panels.getBusbarCalculationDevices(pid),
                    api.panels.getInputCircuitCalcDevices(pid),
                    api.panels.getInputCircuitDeviceConductors(pid),
                    api.panels.getOutputCircuitCalcDevices_Detailed(pid),
                    api.panels.getOutputCircuitDeviceConductors_Detailed(pid),
                    api.panels.get_OutputCircuit_SubDistributionBusbars_Detailed(pid),
                    api.panels.getManuelCalcDevices(pid),
                    storeLossTotals(this.$store, pid)
                ]).then(([busbars, inputDevices, inputConductors, outDevices, outConductors, outBusbars, manuel, totals]) => {
                    this.busbardevicesdata = list(busbars);
                    this.inputcirccalculationdevicesdata = list(inputDevices);
                    this.conductordevicesdata = list(inputConductors);
                    this.circuitcalculationdevicesdata_detailed = list(outDevices);
                    this.circuitdeviceconductorsdata_detailed = list(outConductors);
                    this.subdistributionbusbarsdata_detailed = list(outBusbars);
                    this.manuelcalcdevicesdata = list(manuel);

                    this.total_P_Busbar = totals.busbar;
                    this.total_P_InputCircuit = totals.input;
                    this.allTotal_P_2 = totals.output;
                    this.total_P_manuel = totals.manuel;
                    this.totalPowerLost = totals.total;
                    this.total_P_OutputCircuit_SubDistributionBusbars = this.subdistributionbusbarsdata_detailed
                        .reduce((t, c) => t + (c.Devices || []).reduce((s, d) => s + (parseFloat(d.P_CalcResult) || 0), 0), 0);
                }).catch(() => {
                    this.$buefy.dialog.alert(this.$errorModal({}));
                }).then(() => {
                    this.isLoading = false;
                });
            },
            openCircuitDevices() {
                this.$store.state.previousRoute = this.$route.name;
                this.$store.state.isCircDevicesFromCalculation = true;
                if (this.$store.state.memberId != 'TestMember' && this.$store.state.isAdmin == 1) {
                    router.push('/circuitDevices_Admin');
                } else {
                    router.push('/circuitDevices');
                }
            },
            truncate(numToBeTruncated, numOfDecimals) {
                var theNumber = numToBeTruncated.toString();
                if (theNumber.includes('.')) {
                    var pointIndex = theNumber.indexOf('.');
                    var _result = +(theNumber.slice(0, pointIndex > -1 ? ++numOfDecimals + pointIndex : undefined));
                    var _resultString = _result.toString();
                    if (!_resultString.includes('.')) {
                        return _resultString + '.0';
                    } else {
                        return _result;
                    }
                } else {
                    return theNumber + '.0';
                }
            }
        }
    };
</script>
